module.exports = __webpack_public_path__ + "img/Configure-SEO.b7fa30bc.svg";